import * as Yup from "yup";

export const clientPurchase = Yup.object().shape({
  creditCard: Yup.object().shape({
    holderName: Yup.string().required("Nome do titular é obrigatório"),
    number: Yup.string().required("Número do cartão é obrigatório"),
    expiryMonth: Yup.string().required("Mês de validade é obrigatório"),
    expiryYear: Yup.string().required("Ano de validade é obrigatório"),
    ccv: Yup.string().required("Código de segurança é obrigatório"),
  }),

  customer: Yup.object().shape({
    cpfCnpj: Yup.string().required("CPF ou CNPJ é obrigatório"),
    name: Yup.string().required("Nome é obrigatório"),
    email: Yup.string().email("Email inválido").required("Email é obrigatório"),
    phone: Yup.string().required("Telefone é obrigatório"),
    // mobilePhone: Yup.string().required('Celular é obrigatório'),

    postalCode: Yup.string()
      .nullable()
      .transform((value) => (value ? value.replace(/\D/g, "") : "")),
    street: Yup.string().required("Rua é obrigatória"),
    addressNumber: Yup.string().required("Número é obrigatório"),
  }),
});
